import { ExploreIcon, HeatmapIcon, LeaderboardIcon, OverviewIcon, TrendsIcon } from '@arnold/common';
import { useMemo } from 'react';
import { TFunction } from 'react-i18next';
import type { ReportMenuItem } from './ReportMenu';

export const REPORT_ROUTES = {
  overview: '',
  explore: '/explore',
  trends: '/trends',
  leaderboard: '/leaderboard',
  heatmap: '/heatmap',
  detail: '/detail/:questionIndex',
  metric: '/metric/:metricId',
  tableTest: '/tableTest',
};

/**
 * Menu items of the new report, with routes resolved against the report's base url (`/newReport/:token`).
 */
export const useReportMenuItems = (baseUrl: string, t: TFunction<'newReport'>): ReportMenuItem[] => {
  return useMemo(
    () => [
      { label: t('menu.overview'), icon: <OverviewIcon />, route: `${baseUrl}${REPORT_ROUTES.overview}` },
      { label: t('menu.explore'), icon: <ExploreIcon />, route: `${baseUrl}${REPORT_ROUTES.explore}` },
      { label: t('menu.trends'), icon: <TrendsIcon />, route: `${baseUrl}${REPORT_ROUTES.trends}` },
      { label: t('menu.leaderboard'), icon: <LeaderboardIcon />, route: `${baseUrl}${REPORT_ROUTES.leaderboard}` },
      { label: t('menu.heatmap'), icon: <HeatmapIcon />, route: `${baseUrl}${REPORT_ROUTES.heatmap}` },
      { label: t('menu.tableTest'), icon: <HeatmapIcon />, route: `${baseUrl}${REPORT_ROUTES.tableTest}` },
    ],
    [baseUrl, t],
  );
};
